import { render, staticRenderFns } from "./wenhua.vue?vue&type=template&id=d7f312dc&scoped=true&"
import script from "./wenhua.vue?vue&type=script&lang=js&"
export * from "./wenhua.vue?vue&type=script&lang=js&"
import style0 from "./wenhua.vue?vue&type=style&index=0&id=d7f312dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f312dc",
  null
  
)

export default component.exports